import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import emailjs from '@emailjs/browser';

import './ContactForm.scss';

const ContactForm = () => {
    const { t } = useTranslation();

    const form = useRef();
    const [sending, setSending] = useState(false);
    const [message, setMessage] = useState('');

    const sendEmail = (e) => {
        e.preventDefault();

        setSending(true);
        setMessage('');

        emailjs
            .sendForm(
                'service_hrh2y2c',
                'template_g84srfl',
                form.current,
                {
                    publicKey: '4JzJ9amFhtiVXbgDg',
                }
            )
            .then(() => {
                setMessage(
                    t('contactForm.successMessage')
                );

                form.current.reset();
            })
            .catch(() => {
                setMessage(
                    t('contactForm.errorMessage')
                );
            })
            .finally(() => {
                setSending(false);
            });
    };

    return (
        <form ref={form} onSubmit={sendEmail}>
            <div className="row">

                {/* NAME */}

                <div className="col-lg-6">
                    <div className="form-group">
                        <label htmlFor="name">
                            {t('contactForm.name.label')} *
                        </label>

                        <input
                            id="name"
                            type="text"
                            name="name"
                            className="form-control"
                            placeholder={t(
                                'contactForm.name.placeholder'
                            )}
                            required
                        />
                    </div>
                </div>

                {/* EMAIL */}

                <div className="col-lg-6">
                    <div className="form-group">
                        <label htmlFor="email">
                            {t('contactForm.email.label')} *
                        </label>

                        <input
                            id="email"
                            type="email"
                            name="email"
                            className="form-control"
                            placeholder={t(
                                'contactForm.email.placeholder'
                            )}
                            required
                        />
                    </div>
                </div>

                {/* BIRTHDAY */}

                <div className="col-lg-6">
                    <div className="form-group">
                        <label htmlFor="birthday">
                            {t('contactForm.birthday.label')} *
                        </label>

                        <input
                            id="birthday"
                            type="text"
                            name="birthday"
                            className="form-control"
                            placeholder={t(
                                'contactForm.birthday.placeholder'
                            )}
                            required
                        />
                    </div>
                </div>

                {/* SUBJECT */}

                <div className="col-lg-6">
                    <div className="form-group">
                        <label htmlFor="subject">
                            {t('contactForm.subject.label')} *
                        </label>

                        <select
                            id="subject"
                            name="subject"
                            className="form-control"
                            required
                        >
                            <option value="">
                                {t(
                                    'contactForm.subject.placeholder'
                                )}
                            </option>

                            <option value="appointment">
                                {t(
                                    'contactForm.subject.options.appointment'
                                )}
                            </option>

                            <option value="treatment">
                                {t(
                                    'contactForm.subject.options.treatment'
                                )}
                            </option>

                            <option value="emergency">
                                {t(
                                    'contactForm.subject.options.emergency'
                                )}
                            </option>

                            <option value="costs">
                                {t(
                                    'contactForm.subject.options.costs'
                                )}
                            </option>

                            <option value="other">
                                {t(
                                    'contactForm.subject.options.other'
                                )}
                            </option>
                        </select>
                    </div>
                </div>

                {/* MESSAGE */}

                <div className="col-lg-12">
                    <div className="form-group">
                        <label htmlFor="message">
                            {t('contactForm.message.label')} *
                        </label>

                        <textarea
                            id="message"
                            name="message"
                            className="form-control"
                            placeholder={t(
                                'contactForm.message.placeholder'
                            )}
                            rows="6"
                            required
                        ></textarea>
                    </div>
                </div>

                {/* BUTTON */}

                <div className="col-lg-12">
                    <button
                        type="submit"
                        className="btn appointment-btn"
                        disabled={sending}
                    >
                        {sending
                            ? t('contactForm.sending')
                            : t('contactForm.send')}
                    </button>
                </div>

                {/* STATUS MESSAGE */}

                {message && (
                    <div className="col-lg-12 mt-3">
                        <p>{message}</p>
                    </div>
                )}

            </div>
        </form>
    );
};

export default ContactForm;